import { formatDistanceToNow, format, parseISO } from 'date-fns';

export const timeAgo = (date) => {
  try { return formatDistanceToNow(typeof date === 'string' ? parseISO(date) : date, { addSuffix: true }); }
  catch { return '—'; }
};

export const formatDate = (date, fmt = 'MMM d, yyyy') => {
  try { return format(typeof date === 'string' ? parseISO(date) : date, fmt); }
  catch { return '—'; }
};

export const formatDateTime = (date) => formatDate(date, 'MMM d, yyyy HH:mm');

export const pct = (num, den) => den === 0 ? '0%' : `${Math.round((num / den) * 100)}%`;

export const truncateUrl = (url, maxLen = 50) => {
  if (!url) return '—';
  try { const u = new URL(url); return (u.hostname + u.pathname).slice(0, maxLen) + (url.length > maxLen ? '…' : ''); }
  catch { return url.slice(0, maxLen); }
};

export const statusColor = (status) => ({
  delivered: 'var(--green)',
  sent:      'var(--cyan)',
  failed:    'var(--red)',
  bounced:   'var(--amber)',
}[status] || 'var(--text-muted)');

export const deviceIcon = (type) => ({ desktop: '🖥', mobile: '📱', tablet: '📱', bot: '🤖' }[type] || '?');

export const cn = (...classes) => classes.filter(Boolean).join(' ');
